import { render, staticRenderFns } from "./IndexDotMenuComponent.vue?vue&type=template&id=4a9a70a3&scoped=true&"
import script from "./IndexDotMenuComponent.vue?vue&type=script&lang=js&"
export * from "./IndexDotMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndexDotMenuComponent.vue?vue&type=style&index=0&id=4a9a70a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a70a3",
  null
  
)

export default component.exports